// extracted by mini-css-extract-plugin
export default {"container":"WheelTab_container__LuiNZ","subTabs":"WheelTab_subTabs__49bBQ"};